import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Result } from "antd";
import { useIsOrgAdmin } from "@/common/artemis-operations/organization";
import { FullSpin } from "@/components/base";

export const Route = createFileRoute("/_authenticated/$orgSlug/admin")({
	component: AdminRoute,
});

function AdminRoute() {
	const { isAdmin, isPending } = useIsOrgAdmin();

	if (isPending) return <FullSpin />;
	if (!isAdmin)
		return (
			<Result
				status="403"
				title="Access Denied"
				subTitle="You don't have permission to view this page."
			/>
		);

	// Layout comes from the parent _authenticated route (shared, persistent); the
	// org-admin nav shows in that layout's sidebar. This route only gates + nests.
	return <Outlet />;
}
